import { FC, PropsWithChildren } from 'react'
import styles from './AuthLayout.module.scss'
import background from '../../images/icon-pattern.png'
import { Link } from 'react-router-dom'
import { useContext } from 'react'
import { TibiContext } from '../../context/ContextProvider'
import Button from '../Button/Button'

interface Props extends PropsWithChildren<{}> {
    hideDemoButton?: boolean
    iconBackground?: boolean
    centerVertical?: boolean
    noTopPadding?: boolean
}

const AuthLayout: FC<Props> = ({
    children,
    hideDemoButton,
    iconBackground = true,
    centerVertical = true,
    noTopPadding = false
}) => {
    const { brand } = useContext(TibiContext)
    return (
        <div
            className={`${styles.container} ${centerVertical && styles.centerVertical} ${
                !iconBackground && 'bg-fadedPrimary'
            } ${noTopPadding && styles.notpd}`}
            style={
                iconBackground
                    ? {
                          backgroundImage: 'url(' + background + ')'
                      }
                    : {}
            }
        >
            <header className={`${noTopPadding ? '' : 'md:fixed'} top-0 left-0 z-20 w-full bg-transparent`}>
                <div
                    className={`container px-4 mx-auto w-full flex p-6 items-center ${
                        hideDemoButton ? 'justify-center' : 'justify-between'
                    }`}
                >
                    <Link to='/'>
                        <img
                            src={brand?.logo?.default}
                            className='h-[45px] md:h-[51px] logo'
                            alt={brand?.organisation}
                        />
                    </Link>
                    {!hideDemoButton && (
                        <div>
                            <Button>DEMO AANVRAGEN</Button>
                        </div>
                    )}
                </div>
            </header>
            {children}
        </div>
    )
}

export default AuthLayout
